'use strict';

var ReasonReact = require("reason-react/src/ReasonReact.js");
var GatsbyLink = require("gatsby-link");
var ReactHelmet = require("react-helmet");
var Js_null_undefined = require("bs-platform/lib/js/js_null_undefined.js");
var ReactSocialIcons = require("react-social-icons");

function make(to_, className, activeStyle, activeClassName, children) {
  var p = {
    to: to_,
    className: Js_null_undefined.fromOption(className)
  };
  var p$1 = activeStyle ? Object.assign(p, {
          activeStyle: activeStyle[0]
        }) : p;
  var props = activeClassName ? Object.assign(p$1, {
          activeClassName: activeClassName[0]
        }) : p$1;
  return ReasonReact.wrapJsForReason(GatsbyLink.default, props, children);
}

var Link = /* module */[/* make */make];

function make$1(title, bodyAttributes, meta, children) {
  return ReasonReact.wrapJsForReason(ReactHelmet.default, {
              title: Js_null_undefined.fromOption(title),
              bodyAttributes: Js_null_undefined.fromOption(bodyAttributes),
              meta: Js_null_undefined.fromOption(meta)
            }, children);
}

var Helmet = /* module */[/* make */make$1];

function make$2(urls, className, color, _children) {
  var props = {
    urls: urls,
    className: Js_null_undefined.fromOption(className),
    color: Js_null_undefined.fromOption(color)
  };
  return ReasonReact.wrapJsForReason(ReactSocialIcons.default, props, _children);
}

var SocialIcons = /* module */[/* make */make$2];

function make$3(url, className, color, network, _children) {
  var props = {
    url: url,
    className: Js_null_undefined.fromOption(className),
    color: Js_null_undefined.fromOption(color),
    network: Js_null_undefined.fromOption(network)
  };
  return ReasonReact.wrapJsForReason(ReactSocialIcons.SocialIcon, props, _children);
}

var SocialIcon = /* module */[/* make */make$3];

exports.Link = Link;
exports.Helmet = Helmet;
exports.SocialIcons = SocialIcons;
exports.SocialIcon = SocialIcon;
/* ReasonReact Not a pure module */



// WEBPACK FOOTER //
// ./src/gatsby.js